module.exports = __webpack_public_path__ + "img/calendar-panel-desktop.f9ef71c6.jpg";